export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },
    openForm({commit}) {
        commit('setFormOpen');
    },
    closeForm({commit}) {
        commit('setFormClose');
    },
    openProtocolForm({commit}) {
        commit('setProtocolFormOpen');
    },
    closeProtocolForm({commit}) {
        commit('setProtocolFormClose');
    }
}
